// @ts-expect-error no $hasDep
const MyComponent = $hasDep('react-dnd', '5') ?
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('./OptionsTableDraggableRow.V5').default :
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('./OptionsTableDraggableRow.V3').default;
export default MyComponent;